/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GetRolesResponse {
  id: string;
  name: string;
  normalizedName: string;
}

interface State {
  isRequesting: boolean;
  successPayload: GetRolesResponse[];
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: [],
  errors: [],
};

const getRolesSlice = createSlice({
  name: "users@getRoles",
  initialState,
  reducers: {
    getRoles: (state, action: PayloadAction): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    getRolesSuccess: (state, action: PayloadAction<GetRolesResponse[]>): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    getRolesFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    },
  },
});

export const { getRoles, getRolesSuccess, getRolesFailed } =
  getRolesSlice.actions;
export default getRolesSlice.reducer;
